const roles = [
  'SuperAdmin',
  'Admin',
  'Manager',
  'Payer',
  'Checker',
  'HOD',
  'Hr',
  'SUPERVISOR'
];

export default roles;
